import React, { useState, useEffect } from 'react';
import {
    Box,
    Table,
    Sheet,
    Typography,
    Chip,
    CircularProgress,
    IconButton,
    Tooltip
} from '@mui/joy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Pagination from '@mui/material/Pagination';
import axios from 'axios';
import domain from "../../../util/domain";

export default function InfoRequests() {
    const [data, setData] = useState({ data: [], pagination: {} });
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const fetchInfoRequests = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${domain}/frontoffice/feedback/info-requests`, {
                params: { page, limit: 10 }
            });
            setData(response.data);
        } catch (error) {
            console.error('Error fetching info requests:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInfoRequests();
    }, [page]);

    const handleResolutionUpdate = async (id, resolved) => {
        try {
            await axios.put(`${domain}/frontoffice/feedback/info-requests/${id}/resolve`, {
                resolved
            });
            // Refresh the data after updating
            fetchInfoRequests();
        } catch (error) {
            console.error('Error updating resolution status:', error);
        }
    };

    if (loading) return <CircularProgress />;

    return (
        <Box>
            <Typography level="h4" sx={{ mb: 2 }}>
                Additional Information Requests
            </Typography>

            <Sheet variant="outlined" sx={{ borderRadius: 'md', overflow: 'auto' }}>
                <Table stickyHeader hoverRow>
                    <thead>
                        <tr>
                            <th>Student Name</th>
                            <th>Phone Number</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map(item => (
                            <tr key={item.id}>
                                <td>
                                    <Typography level="body-sm">
                                        {item.student_name}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography level="body-sm">
                                        {item.phone_number}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography level="body-sm">
                                        {new Date(item.createdAt).toLocaleDateString()}
                                    </Typography>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={item.resolved ? 'success' : 'warning'}
                                    >
                                        {item.resolved ? 'Resolved' : 'Pending'}
                                    </Chip>
                                </td>
                                <td>
                                    {item.resolved ? (
                                        <Tooltip title="Mark as Pending">
                                            <IconButton
                                                size="sm"
                                                variant="plain"
                                                color="warning"
                                                onClick={() => handleResolutionUpdate(item.id, false)}
                                            >
                                                <CancelIcon />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title="Mark as Resolved">
                                            <IconButton
                                                size="sm"
                                                variant="plain"
                                                color="success"
                                                onClick={() => handleResolutionUpdate(item.id, true)}
                                            >
                                                <CheckCircleIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Sheet>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2
                }}
            >
                <Pagination
                    count={data.pagination?.total_pages || 1}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                />
            </Box>

            {data.data.length === 0 && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        p: 3,
                        mt: 2
                    }}
                >
                    <Typography level="body-lg">
                        No information requests found
                    </Typography>
                </Box>
            )}
        </Box>
    );
} 